<template>
  <div id="logged-out">
    <h2>We are sorry to have to bring this to your attention...</h2>
    <h4>But your session has expired.</h4>
    <p>Please log in again.</p>
    <b-button :href="url" style="margin: 1em;" class="btn-purple">Log In</b-button>
    <!-- <b-button href = 'http://localhost:3030/authRequest/analytics' style="margin: 1em;" class="btn-purple">Log In</b-button> -->
    <p></p>
    <img width="340" src="../assets/images/time-out.gif" alt="session expired" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "loggedOut",
  computed: {
    url() {
      let service = this.organization.orgId;
      return `${this.authUrl}/authRequest/${service}`;
    },
    ...mapGetters(["authUrl", "organization"]),
  },
};
</script>

<style lang="scss" scoped>
#logged-out {
  padding: 0.5em;
  padding-top: 4em;
}
</style>
